if (!customElements.get("variant-options")) {
  customElements.define(
    "variant-options",
    class VariantOptions extends HTMLElement {
      whenLoaded = Promise.all([customElements.whenDefined("gallery-section")]);
      constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
        this.addEventListener("keydown", this.onKeyDown);

        this.container = document.querySelector(
          `section[data-product-handle="${this.getAttribute("data-product-handle")}"]`,
        );
      }

      connectedCallback() {
        this.whenLoaded.then(() => {
          this.initialize();
        });
      }

      disconnectedCallback() {}

      initialize() {
        this.updateOptions();
        this.updateMasterId();
        this.updateGallery();
        this.updateVariantStatuses();
        this.updateDropdownButtons();
      }

      onKeyDown(event) {
        if (event.key === "Enter" || event.keyCode === 13) {
          const input = event.target.querySelector("input");
          input?.click();
          // this.onVariantChange();
        }
      }

      onVariantChange() {
        const variantChangeStartEvent = new CustomEvent("variantChangeStart", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeStartEvent);
        this.updateOptions();
        this.updateMasterId();
        // Avoid double gallery transition:
        // for custom.variant_images flow, gallery is replaced once via AJAX section HTML.
        if (!this.shouldReplaceGalleryByVariantImage()) {
          this.updateGallery();
        }
        this.toggleAddButton(!this.currentVariant?.available);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();
        this.updateDropdownButtons();

        if (!this.currentVariant) {
          this.setUnavailable();
        } else {
          if (!this.shouldReplaceGalleryByVariantImage()) {
            this.updateMedia();
          }
          this.lenOfVariantOptions =
            document.querySelectorAll("variant-options").length;
          if (this.lenOfVariantOptions === 1) {
            this.updateURL();
          }
          this.updateVariantInput();
          this.renderProductInfo();
          this.updateShareUrl();
        }
        const variantChangeEndEvent = new CustomEvent("variantChangeEnd", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeEndEvent);
      }

      updateGallery() {
        const mediaGallery = document.getElementById(
          `MediaGallery-${this.dataset.section}`,
        );

        let media_id = false;
        if (this.currentVariant && this.currentVariant.featured_media) {
          media_id = this.currentVariant.featured_media.id;
        }

        mediaGallery?.filterSlides(this.options, media_id, true);
      }

      hasColorOption() {
        const optionTitles = Array.from(
          this.querySelectorAll(".wt-product__option__title .label"),
        ).map((el) => (el.textContent || "").toLowerCase());

        return optionTitles.some(
          (label) => label.includes("color") || label.includes("colour"),
        );
      }

      getSelectedColorInput() {
        const checkedInputs = Array.from(
          this.querySelectorAll('.product-form__input input[type="radio"]:checked'),
        );

        return (
          checkedInputs.find((input) => {
            const name = (input.getAttribute("name") || "").toLowerCase();
            return name.includes("color") || name.includes("colour");
          }) || null
        );
      }

      getVariantImagesMetafieldData() {
        this.variantImagesMetafieldData =
          this.variantImagesMetafieldData ||
          JSON.parse(
            this.querySelector('[data-variant-images-metafield]')?.textContent ||
              '{"variants":[]}',
          );
        return this.variantImagesMetafieldData;
      }

      currentVariantHasMetafieldImages() {
        if (!this.currentVariant?.id) return false;
        const variantImagesData = this.getVariantImagesMetafieldData();
        const item = variantImagesData?.variants?.find(
          (variant) => String(variant.id) === String(this.currentVariant.id),
        );
        return Boolean(item?.hasVariantImages);
      }

      shouldReplaceGalleryByVariantImage() {
        if (!this.currentVariant) return false;
        if (!this.hasColorOption()) return false;
        if (!this.currentVariantHasMetafieldImages()) return false;
        return true;
      }

      replaceGalleryFromHtml(htmlDocument) {
        const targetId = `MediaGallery-${this.dataset.section}`;
        const sourceId = `MediaGallery-${
          this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
        }`;
        const destinationGallery = document.getElementById(targetId);
        const sourceGallery = htmlDocument.getElementById(sourceId);

        if (!destinationGallery || !sourceGallery) return;

        // Same photos (only the size changed): keep the gallery as it is. Replacing it anyway emptied the photo
        // column for up to a second and reloaded every photo on each size click (2026-10-20).
        const photosOf = (gallery) =>
          Array.from(gallery.querySelectorAll("img"))
            .map((img) => (img.getAttribute("data-src") || img.getAttribute("src") || "").split("?")[0])
            .filter(Boolean)
            .join("|");
        if (photosOf(destinationGallery) && photosOf(destinationGallery) === photosOf(sourceGallery)) return;

        // Full node replacement re-triggers gallery-section custom element lifecycle.
        destinationGallery.outerHTML = sourceGallery.outerHTML;
      }

      updateDropdownButtons(){
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option"),
        );
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked,
          )?.value || '';
        });

        fieldsets.forEach((fieldset) => {
          const dropdown = fieldset.querySelector(
            ".wt-product__option__dropdown",
          );
          if (dropdown) {
            const checkedInput = fieldset.querySelector('fieldset input:checked')
            if(!checkedInput) return
            const isInputDisabled = checkedInput?.classList.contains('disabled')
            dropdown.classList.toggle('wt-product__option__dropdown--unavailable', isInputDisabled)
          }
        });
      }

      updateOptions() {
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option"),
        );
        this.options = fieldsets.map((fieldset) => {
          return (
            Array.from(fieldset.querySelectorAll("input")).find(
              (radio) => radio.checked,
            )?.value || ""
          );
        });

        this.checkedOptions = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked,
          ) || '';
        });

        fieldsets.forEach((fieldset, index) => {
          const selectedOption = this.options[index];

          if (!selectedOption) return;

          fieldset.querySelector(
            ".wt-product__option__title .value",
          ).innerHTML = selectedOption;
          const dropdownSpan = fieldset.querySelector(
            ".wt-product__option__dropdown span",
          );
          if (dropdownSpan) dropdownSpan.innerHTML = selectedOption;
        });
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData()?.find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      updateMedia() {
        if (!this.currentVariant) return;
        this.setAttribute("data-variant-id", this.currentVariant?.id);
        if (!this.currentVariant.featured_media) return;
        this.setAttribute(
          "data-featured-image",
          this.currentVariant?.featured_media?.preview_image?.src,
        );
        this.setAttribute(
          "data-featured-image-id",
          this.currentVariant?.featured_media?.id,
        );

        const modalContent = document.querySelector(
          `#ProductModal-${this.dataset.section} .product-media-modal__content`,
        );
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(
          `[data-media-id="${this.currentVariant.featured_media.id}"]`,
        );
        modalContent.prepend(newMediaModal);
      }

      updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${this.dataset.url}?variant=${this.currentVariant.id}`,
        );
      }

      updateShareUrl() {
        const shareButton = document.getElementById(
          `Share-${this.dataset.section}`,
        );
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(
          `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
        );
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
        );
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateVariantStatuses() {
        const availableVariants = this.variantData?.filter(
          (variant) => variant.available === true,
        );
        const inputWrappers = [
          ...this.querySelectorAll(".product-form__input"),
        ];
        inputWrappers.forEach((option, index) => {
          const optionInputs = [
            ...option.querySelectorAll('input[type="radio"], option'),
          ];

          if (index === 0 && this.currentVariant?.options.length > 1) {
            // Update first option (e.g. Color) based on all other selected option values
            let filteredVariants = availableVariants || [];
            for (let i = 1; i < inputWrappers.length; i++) {
              const selectedVal = inputWrappers[i]?.querySelector(":checked")?.value;
              if (selectedVal) {
                filteredVariants = filteredVariants.filter(
                  (variant) => variant[`option${i + 1}`] === selectedVal,
                );
              }
            }
            const availableValues = filteredVariants.map((variant) => variant.option1);
            this.setInputAvailability(optionInputs, availableValues);
            return;
          }

          const previousOptionSelected =
            inputWrappers[index - 1]?.querySelector(":checked")?.value;
          const availableOptionInputsValue = (availableVariants || [])
            .filter(
              (variant) =>
                variant.available &&
                variant[`option${index}`] === previousOptionSelected,
            )
            .map((variantOption) => variantOption[`option${index + 1}`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
      }

      setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
          if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
            input.classList.remove("disabled");
          } else {
            input.classList.add("disabled");
          }
        });
      }

      updatePickupAvailability() {
        const pickUpAvailability = document.querySelector(
          "pickup-availability",
        );
        if (!pickUpAvailability) return;

        pickUpAvailability.dataset.variantId = this.currentVariant?.id;
        if (this.currentVariant && this.currentVariant.available) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
          pickUpAvailability.removeAttribute("available");
          pickUpAvailability.innerHTML = "";
        }
      }

      removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        try {
          productForm?.handleErrorMessage();
        } catch (err) {
          console.log(err);
        }
      }

      renderProductInfo() {
        const requestedVariantId = this.currentVariant?.id;
        const sectionId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section;

        fetch(
          `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        )
          .then((response) => response.text())
          .then((responseText) => {
            // prevent unnecessary ui changes from abandoned selections
            if (this.currentVariant?.id !== requestedVariantId) return;

            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const destination = document.getElementById(
              `price-${this.dataset.section}`,
            );
            const source = html.getElementById(
              `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
            );
            const skuSource = html.getElementById(
              `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
            );
            const skuDestination = document.getElementById(
              `Sku-${this.dataset.section}`,
            );
            const inventorySource = html.getElementById(
              `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
            );
            const inventoryDestination = document.getElementById(
              `Inventory-${this.dataset.section}`,
            );

            if (source && destination) destination.innerHTML = source.innerHTML;
            if (inventorySource && inventoryDestination)
              inventoryDestination.innerHTML = inventorySource.innerHTML;
            if (skuSource && skuDestination) {
              skuDestination.innerHTML = skuSource.innerHTML;
              skuDestination.classList.toggle(
                "visibility-hidden",
                skuSource.classList.contains("visibility-hidden"),
              );
            }

            const price = document.getElementById(
              `price-${this.dataset.section}`,
            );

            if (price) price.classList.remove("visibility-hidden");

            if (inventoryDestination)
              inventoryDestination.classList.toggle(
                "visibility-hidden",
                inventorySource.innerText === "",
              );

            // "Next shipment" card + the ship window the order will carry (snippets/shipment-batch-card.liquid)
            const batchSource = html.getElementById(`ShipmentBatch-${sectionId}`);
            const batchDestination = document.getElementById(
              `ShipmentBatch-${this.dataset.section}`,
            );
            if (batchSource && batchDestination) {
              batchDestination.innerHTML = batchSource.innerHTML;
              batchDestination.dataset.state = batchSource.dataset.state || "none";
              batchDestination.dataset.atcLabel = batchSource.dataset.atcLabel || "";
              batchDestination.dataset.shipsWindow = batchSource.dataset.shipsWindow || "";
              batchDestination.hidden = batchSource.hasAttribute("hidden");
            }
            const statusSource = html.getElementById(`ShipmentStatus-${sectionId}`);
            const statusDestination = document.getElementById(
              `ShipmentStatus-${this.dataset.section}`,
            );
            if (statusSource && statusDestination) {
              statusDestination.innerHTML = statusSource.innerHTML;
              statusDestination.hidden = statusSource.hasAttribute("hidden");
            }
            const shipsWindowInput = document.getElementById(
              `ShipsWindow-${this.dataset.section}`,
            );
            if (shipsWindowInput) {
              const windowValue = batchSource?.dataset.shipsWindow || "";
              shipsWindowInput.value = windowValue;
              shipsWindowInput.disabled = windowValue === "";
            }

            const addButtonUpdated = html.getElementById(
              `ProductSubmitButton-${sectionId}`,
            );
            this.toggleAddButton(
              addButtonUpdated
                ? addButtonUpdated.hasAttribute("disabled")
                : true,
              window.variantStrings.soldOut,
            );

            publish(PUB_SUB_EVENTS.variantChange, {
              data: {
                sectionId: sectionId,
                html,
                variant:this.currentVariant
              },
            });

            if (this.shouldReplaceGalleryByVariantImage()) {
              this.replaceGalleryFromHtml(html);
            }
          });
      }

      // Always sets the label with the disabled state so the two can't disagree.
      toggleAddButton(disable = true, text = window.variantStrings.soldOut) {
        const productForm = document.getElementById(
          `product-form-${this.dataset.section}`,
        );
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          // The "Next shipment" card can rename the button (Buy now); otherwise the theme default
          const batchLabel = document.getElementById(
            `ShipmentBatch-${this.dataset.section}`,
          )?.dataset.atcLabel;
          addButtonText.textContent = batchLabel || window.variantStrings.addToCart;
        }

        // The sticky buy button mirrors the main one so the two never disagree
        const stickyButton = document.querySelector("sticky-buy-button button");
        if (stickyButton) {
          stickyButton.toggleAttribute("disabled", disable);
          const stickyText = stickyButton.querySelector("span");
          if (stickyText) stickyText.textContent = addButtonText.textContent;
        }
      }

      setUnavailable() {
        const button = document.getElementById(
          `product-form-${this.dataset.section}`,
        );
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add("visibility-hidden");
        if (inventory) inventory.classList.add("visibility-hidden");
        if (sku) sku.classList.add("visibility-hidden");
      }

      getVariantData() {
        if (this.variantData) return this.variantData;

        this.variantData = JSON.parse(
          this.querySelector('[type="application/json"]').textContent,
        );
        // Variants Shopify sells through "Continue selling" that this market
        // has no stock for (see snippets/variant-sellable.liquid).
        const marketSoldOut = JSON.parse(
          this.querySelector("[data-market-sold-out]")?.textContent || "[]",
        );
        this.variantData.forEach((variant) => {
          if (marketSoldOut.includes(variant.id)) variant.available = false;
        });
        return this.variantData;
      }
    },
  );
}
// customElements.define('variant-options', VariantOptions);
